import React from 'react';
import useAuthGuard from '../hooks/useAuthGuard';

const AuthGuard = ({ redirectTo = '/signin', fallback = null, children }) => {
  const { checking, authenticated } = useAuthGuard(redirectTo);

  if (checking) return fallback;
  if (!authenticated) return null; // navigate handles redirect; prevent child effects

  return children;
};

export default AuthGuard;
    